import { Component } from '@angular/core';

@Component({
  selector: 'ottimizza-center',
  templateUrl: './vertical-aligner.component.html',
  styleUrls: ['./vertical-aligner.component.scss']
})
export class VerticalAlignerComponent {}
